import { routes as inicialPage } from "@/modules/inicialPage";
// import { routes as formularios } from '@/modules/formularios'
import { routes as inscricao } from "@/modules/inscricao";
import { routes as dashboard } from "@/modules/dashboard";
import { routes as user } from "@/modules/user";

import { routes as auth } from "@/modules/auth";

export default [
  {
    path: "*",
    redirect: "/inscricao/auth/dashboard",
  },
  ...inicialPage,
  // ...formularios,
  ...inscricao,
  ...auth,
  ...dashboard,
  ...user,
];
